export default __webpack_public_path__ + "static/media/Luffy.ac17b47d.png";